let view = null;

export default {
	namespace: 'template-about-us',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: AboutUsView } = await import(
			/* webpackChunkName: "about-us-view" */ '../../templates/AboutUsView'
		);
		view = new AboutUsView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
